import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=787bd6b2&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=ts"
export * from "./Supplier.vue?vue&type=script&lang=ts"
import style0 from "./Supplier.vue?vue&type=style&index=0&id=787bd6b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787bd6b2",
  null
  
)

export default component.exports